import { Record, List } from 'immutable';
import { DesignTemplates } from 'records/DesignTemplate';

const defaultValues = {
  typeId: null,
  typeName: '',
  typeItemId: null,
  typeItemTextKey: '',
  typeItemName: '',
  iconName: '',
  iconURL: '',
  imageName: '',
  imageURL: '',
  displayDate: '',
  designTemplateCount: null,
  designTemplates: DesignTemplates(),
};

export default class Theme extends Record(defaultValues, Theme) {
  constructor(values) {
    super({
      ...values,
      designTemplates: values && values.designTemplates
                       ?DesignTemplates(values.designTemplates)
                       :defaultValues.designTemplates,
    });
  }

  static getThemeDataByTypeItemId(themeList, typeItemId) {
    return themeList.filter((oneTheme) => {
      return oneTheme.get('typeItemId') === typeItemId;
    });
  }

  static setThemeDataByTypeItemId(themeList, typeItemId, designTemplates) {
    return themeList.map((oneTheme) => {
      return oneTheme.get('typeItemId') === typeItemId? oneTheme.set('designTemplates', designTemplates): oneTheme;
    });
  }

}

export const Themes = (data) => {
  let themes = new List();
  if (data) {
    data.forEach((value) => {
      themes = themes.push((value instanceof Theme)? value: (new Theme(value)));
    });
  }
  return themes;
};
